<template>
  <div>
    <h3>推送</h3>
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item label="任务id">
        <el-input v-model="filter.taskInfoId" placeholder="职位id"></el-input>
      </el-form-item>
      <el-form-item label="乙方id">
        <el-input
          v-model.number="filter.userId"
          placeholder="乙方id"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="fetch(1)" size="mini"
            >查询</el-button
          >
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="resetQuery()" size="mini"
            >重置</el-button
          >
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="taskInfoId" label="任务id"></el-table-column>
      <el-table-column prop="title" label="任务标题"> </el-table-column>
      <el-table-column prop="userId" label="乙方id"></el-table-column>
      <el-table-column prop="partyBName" label="乙方昵称">
        <template slot-scope="scope">
          <a
            :href="`${frontUrl}/taskHostingPage/detail?taskInfoId=${scope.row.taskInfoId}`"
            target="_blank"
            >{{ scope.row.partyBName }}</a
          >
        </template>
      </el-table-column>
      <el-table-column prop="pushRule" label="匹配类型">
        <template slot-scope="scope">{{
          map.match.pushRule[scope.row.pushRule]
        }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="推送时间"></el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";

const { taskInfo } = api;

export default {
  name: "matchList",
  data() {
    return {
      map,
      loading: true,
      list: [],
      total: 0,
      limit: 20,
      pageNum: 1,
      filter: {
        taskInfoId: "",
        userId: "",
      },
      mismatchForm: {
        inaccurateReason: "",
        inaccurateRemark: "",
      },
      dialog: {
        mismatch: false,
      },
      curData: {},
      reset: true,
    };
  },
  created() {},
  computed: {
    id() {
      return this.$route.query.taskInfoId;
    },
  },
  watch: {
    pageNum() {
      this.fetch(2);
    },
    "curData.id"() {
      this.mismatchForm.inaccurateReason = "";
      this.mismatchForm.inaccurateRemark = "";
      this.$refs["mismatchForm"] && this.$refs["mismatchForm"].resetFields();
    },
  },
  methods: {
    resetQuery() {
      this.filter.taskInfoId = "";
      this.filter.userId = "";
      this.reset = false;
      this.fetch();
    },
    toggleDialog(name, data) {
      this.dialog[name] = !this.dialog[name];
      if (data) {
        this.curData = data;
      } else {
        this.curData = {};
        this.mismatchForm.inaccurateReason = "";
        this.mismatchForm.inaccurateRemark = "";
      }
    },
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }

      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;

      let { taskInfoId, userId } = this.filter;

      let obj = {
        pageNum: pageNum,
        limit: limit,
        taskInfoId: this.taskInfoId,
        taskInfoId,
        userId: Number.isInteger(userId) ? userId : "",
      };
      if (this.reset) {
        this.$set(obj, "taskInfoId", this.id);
      }

      let res = await taskInfo.pushLogList(obj);
      console.log(res);
      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
  },
  mounted() {
    // this.taskInfoId = this.$route.query.taskInfoId
    this.fetch();
  },
};
</script>
<style>
.dialog-mismatch .el-radio {
  display: block;
  margin: 0;
  line-height: 24px;
}
.dialog-mismatch .el-radio + .el-radio {
  margin-left: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/taskManage/taskPushLog.vue